import { memo } from 'react';

import MembersRemoveFlow from './MembersRemoveFlow';

/**
 * Two-step bulk Remove (soft delete) for the selected members, as in the prototype: step 1 lists
 * who is included, step 2 asks to type the confirmation word. The per-person flow with its
 * "what they lose" summary lives in the member detail (CT-5574).
 *
 * @param {object} props
 * @param {{ id: string, displayName: string, email: string }[]} props.members Members about to be removed (empty: closed).
 * @param {boolean} [props.isBusy] Removing: Back, the way out and the red button are locked.
 * @param {() => void} props.onConfirm
 * @param {() => void} props.onCancel
 */
const MembersRemoveModal = ({ members, isBusy = false, onConfirm, onCancel }) =>
  members.length ? (
    <MembersRemoveFlow members={members} isBusy={isBusy} onConfirm={onConfirm} onCancel={onCancel} />
  ) : null;

export default memo(MembersRemoveModal);
